import { QueryClient, useQuery } from 'react-query'

import { CatalogsByQueryInput } from 'src/contexts/discovery'
import { fetchCatalogsByQuery } from 'src/contexts/loader/catalogLoader'

export const useCatalogHighlighting = (
  catalogId: string,
  queryInput: CatalogsByQueryInput,
  onSuccess?: (highlighting: string[]) => void,
) => {
  return useQuery(
    ['catalogHighlighting', catalogId],
    () =>
      fetchCatalogsByQuery(
        { ...queryInput, rows: 1, hl: true } as CatalogsByQueryInput,
        new QueryClient(),
      ),
    {
      enabled: false,
      onSuccess: (data) => {
        const highlights =
          data.metadata.highlighting?.[catalogId]?.['fulltext-search']
        if (highlights && onSuccess) {
          onSuccess(highlights)
        }
      },
    },
  )
}
